import { FileType } from '@office-start/document-types';
export function getNewDocLinkTarget(app, shouldOpenInUIHost, linkTargetOverride) {
    //TODO: confirm if following still applys
    //     const candidate = this.createLinkCandidates.get(app);
    //     if (this.capabilitiesService.capabilities.capPopupEnabled &&
    //         (app === FileType.Word || app === FileType.Excel || app === FileType.PowerPoint || app === FileType.Visio || app === FileType.OneNote) &&
    //         this.accessTokenService.hasCAPError('Graph')) {
    //         // These file types use the Graph token to create docs. If we need to show a popup dialog for CAP, open the new document in the same tab to reduce tab switching.
    //         return LinkTarget.SameFrame;
    //     }
    if (app === FileType.Fluid || app === FileType.FluidActivityBlueprint) {
        return '_self';
    }
    return (linkTargetOverride !== null && linkTargetOverride !== void 0 ? linkTargetOverride : shouldOpenInUIHost) ? '_self' : '_blank';
}
//# sourceMappingURL=getNewDocLinkTarget.js.map